import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

// 호스티드 에이전트 채팅 — 런타임 SSE 소비(제어 채널)
import AgentChatController from "./agent_chat_controller"
application.register("agent-chat", AgentChatController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import PinInputController from "./pin_input_controller"
application.register("pin-input", PinInputController)

import KeyRecoveryModalController from "./key_recovery_modal_controller"
application.register("key-recovery-modal", KeyRecoveryModalController)

import LoginTabController from "./login_tab_controller"
application.register("login-tab", LoginTabController)

import AccountCardController from "./account_card_controller"
application.register("account-card", AccountCardController)

import SlotDetailController from "./slot_detail_controller"
application.register("slot-detail", SlotDetailController)

import OauthLoginController from "./oauth_login_controller"
application.register("oauth-login", OauthLoginController)

import OauthPostmessageController from "./oauth_postmessage_controller"
application.register("oauth-postmessage", OauthPostmessageController)

import VaultController from "./vault_controller"
application.register("vault", VaultController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import OwnershipPinController from "./ownership_pin_controller"
application.register("ownership-pin", OwnershipPinController)

import SlotSelectorController from "./slot_selector_controller"
application.register("slot-selector", SlotSelectorController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import ListingFormController from "./listing_form_controller"
application.register("listing-form", ListingFormController)

import CommentController from "./comment_controller"
application.register("comment", CommentController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import CancelConfirmController from "./cancel_confirm_controller"
application.register("cancel-confirm", CancelConfirmController)

import ChatBadgeController from "./chat_badge_controller"
application.register("chat-badge", ChatBadgeController)

import AddressTruncateController from "./address_truncate_controller"
application.register("address-truncate", AddressTruncateController)

// 지갑 주소 등 긴 문자열을 클립보드로 복사(슬롯 지갑 카드)
import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import BuyConfirmController from "./buy_confirm_controller"
application.register("buy-confirm", BuyConfirmController)

import NotConnectedModalController from "./not_connected_modal_controller"
application.register("not-connected-modal", NotConnectedModalController)

// 2026-05-14 추가 — /signup 이메일 중복확인 버튼 UX 처리.
import SignupEmailCheckController from "./signup_email_check_controller"
application.register("signup-email-check", SignupEmailCheckController)

// 2026-05-20 추가 — /accounts 정렬/보기 toolbar 즉시 active 토글 + 로딩 spinner
import AccountsToolbarController from "./accounts_toolbar_controller"
application.register("accounts-toolbar", AccountsToolbarController)

// /accounts 계정(슬롯) 삭제 확인 모달 — 단순 예/아니오 후 DELETE 제출
import SlotDeleteConfirmController from "./slot_delete_confirm_controller"
application.register("slot-delete-confirm", SlotDeleteConfirmController)

// 위임 생성 폼 제출 중 로딩 스피너 토글 + 제출 버튼 비활성(중복 제출 방지)
import DelegationSubmitController from "./delegation_submit_controller"
application.register("delegation-submit", DelegationSubmitController)

// 위임 폼 체크박스 그룹별 "전체 선택" 마스터 체크박스(그룹당 독립 인스턴스)
import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

// 위임 폼 문맥 노출 — 연결된 스코프/권한 체크가 켜질 때만 제약(한도) 패널을 노출
import RevealController from "./reveal_controller"
application.register("reveal", RevealController)
